var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('figure',{style:('background-image: url('+_vm.photo+')')}),_c('hgroup',[_c('h4',[_vm._v(_vm._s(_vm.product.Name))]),_c('cite',[_vm._v(_vm._s(_vm.date)+" "+_vm._s(_vm.time))]),_c('cite',[_vm._v(_vm._s(_vm.guests)+" guests")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }